import React, { useState, useEffect } from 'react'
import objectPath from 'object-path'
import { Modal } from 'react-bootstrap'
import { useRouteMatch, useLocation } from 'react-router-dom'
import styles from 'designer/styles/modal.module.css'

import { getForm, getPage } from 'designer/component/action/Design'
import ExternalComponent from './index'
import { debounceCallback } from 'utility/debounceCallback.util'

const ExternalModal = ({
  code,
  modalCode,
  onCloseModal,
  data,
  designerData,
  defaultProps,
  onUpdateData,
  onSelectRow,
  callback,
  modalProps,
}) => {
  const {
    size,
    title,
    modalHeaderStyle = {},
    textHeaderStyle = {},
  } = modalProps
  const [uischema, setUischema] = useState({})
  const [isOpen, setIsOpen] = useState(false)
  const { form, page } = code
  const match = useRouteMatch()
  const location = useLocation()
  let search = location.search || []
  let pathParams = match.params
  let urlSearchParams = new URLSearchParams(search)
  let queryParams = Object.fromEntries([...urlSearchParams])

  const createModal = async (modalCode) => {
    let design = null
    let type = ''
    let useFormData = true
    if (form) {
      type = 'form'
      design = await getForm(form)
    } else if (page) {
      type = 'page'
      design = await getPage(
        page,
        pathParams,
        queryParams,
        location,
        useFormData
      )
    }
    if (!objectPath.get(design, 'formDesign.formDesignId')) return null
    let uischema = {}
    let designerProps =
      objectPath.get(design, 'jsonForm.designerPropsData.receive') || []
    let receiveProps = designerProps
    objectPath.set(uischema, 'ui.close', false)
    objectPath.set(uischema, 'ui.formDesign', design.formDesign)
    objectPath.set(uischema, 'ui.jsonForm', design.jsonForm)
    objectPath.set(uischema, 'ui.receiveProps', receiveProps)
    objectPath.set(uischema, 'ui.systemData', defaultProps)
    objectPath.set(uischema, 'title', design.formDesign.name)
    objectPath.set(uischema, 'type', type)
    objectPath.set(uischema, 'isCustomComponent', true)
    setIsOpen(true)
    setUischema(uischema)
  }

  useEffect(() => {
    if (modalCode) {
      debounceCallback(createModal, [modalCode], 'create-external-modal', 100)
    }
    return () => {
      setIsOpen(false)
    }
  }, [modalCode])

  return (
    <>
      {size === 'fullscreen' ? (
        <Modal
          fullscreen="true"
          dialogClassName={styles.modalFullScreen}
          className="pl-0"
          show={isOpen}
        >
          <Modal.Header
            closeButton
            onHide={onCloseModal}
            style={modalHeaderStyle}
          >
            <h5 className="mb-0" style={textHeaderStyle}>
              {title || uischema.title}
            </h5>
          </Modal.Header>
          <Modal.Body className="p-0">
            {modalCode && (
              <ExternalComponent
                designerData={designerData}
                data={data}
                onUpdateData={onUpdateData}
                onSelectRow={onSelectRow}
                onCloseModal={onCloseModal}
                uischema={uischema}
                designCode={modalCode}
                callback={callback}
                isOpenModal={isOpen}
              />
            )}
          </Modal.Body>
        </Modal>
      ) : (
        <Modal show={isOpen} size={size}>
          <Modal.Header
            closeButton
            onHide={onCloseModal}
            style={modalHeaderStyle}
          >
            <h5 className="mb-0" style={textHeaderStyle}>
              {title || uischema.title}
            </h5>
          </Modal.Header>
          <Modal.Body className="p-0">
            {modalCode && (
              <ExternalComponent
                designerData={designerData}
                data={data}
                onUpdateData={onUpdateData}
                onSelectRow={onSelectRow}
                onCloseModal={onCloseModal}
                uischema={uischema}
                designCode={modalCode}
                callback={callback}
                isOpenModal={isOpen}
              />
            )}
          </Modal.Body>
        </Modal>
      )}
    </>
  )
}

ExternalModal.defaultProps = {
  code: { form: '', page: '' },
  modalCode: false,
  onCloseModal: () => {},
  data: {},
  designerData: {},
  callback: {},
  onUpdateComponentData: () => {},
  onUpdateData: () => {},
  onSelectRow: () => {},
  onCloseModal: () => {},
}

export default ExternalModal
